import { supabase } from "@/lib/supabase/client";

const BUCKET = "event-documents";
const STORAGE_PREFIX = `storage://${BUCKET}/`;
const MAX_FILE_SIZE = 25 * 1024 * 1024;
const ALLOWED_TYPES = new Set([
  "application/pdf",
  "application/msword",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  "image/jpeg",
  "image/png",
  "image/webp",
  "image/gif",
]);

export async function uploadDocumentFile(file: File, organizationId: string, eventId: string): Promise<string> {
  if (!ALLOWED_TYPES.has(file.type)) throw new Error("Selecciona un archivo PDF, Word, JPG, PNG, WEBP o GIF.");
  if (file.size > MAX_FILE_SIZE) throw new Error("El archivo debe pesar menos de 25 MB.");
  const { data, error: userError } = await supabase.auth.getUser();
  if (userError || !data.user) throw new Error("Tu sesión venció. Vuelve a iniciar sesión.");
  const extension = (file.name.split(".").pop() || "file").toLowerCase().replace(/[^a-z0-9]/g, "");
  const path = `${organizationId}/${eventId}/${data.user.id}/${crypto.randomUUID()}.${extension}`;
  const { error } = await supabase.storage.from(BUCKET).upload(path, file, { cacheControl: "3600", contentType: file.type, upsert: false });
  if (error) throw new Error("No se pudo subir el archivo. Inténtalo nuevamente.");
  return `${STORAGE_PREFIX}${path}`;
}

export async function resolveDocumentUrl(value: string): Promise<string> {
  if (!value.startsWith(STORAGE_PREFIX)) return value;
  const { data, error } = await supabase.storage.from(BUCKET).createSignedUrl(value.slice(STORAGE_PREFIX.length), 60 * 10);
  if (error || !data.signedUrl) throw new Error("No se pudo abrir el archivo.");
  return data.signedUrl;
}

export async function removeDocumentFile(value: string): Promise<void> {
  if (!value.startsWith(STORAGE_PREFIX)) return;
  const { error } = await supabase.storage.from(BUCKET).remove([value.slice(STORAGE_PREFIX.length)]);
  if (error) throw new Error("No se pudo eliminar el archivo almacenado.");
}
